import { maybe } from '@passionware/monads';
import classNames from 'classnames';
import React from 'react';
import SYSTEM_COLOURS from 'v1/helpers/consts/SYSTEM_COLOURS';
import './Loading.scss';
import { LoadingSpinner } from '../../../../../v5/design-system/LoadingSpinner';
import { useTranslation } from 'react-i18next';

export interface LoadingProps {
  className?: string;
  text?: string;
  light?: boolean;
  layout?: 'default' | 'fullscreen';
}

export function Loading({
  className,
  text,
  light,
  layout = 'default'
}: LoadingProps) {
  const { t } = useTranslation('v1_shared');

  // Determine if text should be disabled based on textPlacement or options.disableText

  return (
    <div
      data-id="Loading"
      className={classNames(
        'Loading tailwind-root',
        { default: '', fullscreen: 'pageCenter' }[layout],
        className
      )}
    >
      <div className="Loading-container animate-in">
        <div className="Loading-spinner">
          <LoadingSpinner
            color={light ? SYSTEM_COLOURS.WHITE : SYSTEM_COLOURS.BLACK}
            className="size-[24px]"
          />
        </div>
        {maybe.isPresent(maybe.fromTruthy(text)) && <h5>{text}</h5>}
      </div>
    </div>
  );
}

export default Loading;
